import { render, staticRenderFns } from "./TalkImage.vue?vue&type=template&id=2b4b4305&scoped=true&"
import script from "./TalkImage.vue?vue&type=script&lang=ts&"
export * from "./TalkImage.vue?vue&type=script&lang=ts&"
import style0 from "./TalkImage.vue?vue&type=style&index=0&id=2b4b4305&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b4305",
  null
  
)

export default component.exports